<template>
  <section class="form-section">
    <div class="form-section__head">
      <h3>입금계좌 정보</h3>
    </div>
    <div>
      <dl class="form-list__row form-list__row--text-only">
        <dt class="form-list__key">
          고객명
        </dt>
        <dd>
          <div>
            {{ orgCstmNm }}
          </div>
        </dd>
      </dl>
      <dl v-if="isForeigner && isPassYn !=='Y'" class="form-list__row">
                <div class="form-guide-text font-red">
          계좌입력이 안될 경우 PASS 인증을 진행 후 계좌 입력이 가능합니다.
        </div>
        <div class="btn-wrap">
          <a href="javascript:void(0);" class="talk-btn btn-black" @click.stop.prevent="certPass">PASS 인증</a>
        </div>
      </dl>
      <dl v-if="isForeigner && isPassYn ==='Y'" class="form-list__row">
        <div class="form-guide-text font-red">
          PASS 인증이 완료되었습니다. 계좌 입력이 가능합니다.
        </div>
      </dl>
      <dl class="form-list__row">
        <dt class="form-list__key">
          예금주명
          <span class="font-red">(필수)</span>
          <div class="div-checkedSameName">
            <DxCheckBox
              text="고객명과 동일"
              v-model="checkedSameName"
              @valueChanged="handleCheckedSameName"
              width="100%"
            />
          </div>
        </dt>
        <dd>
          <div class="agrm-form-input-area" style="margin-bottom: 6px;">
            <DxTextBox
              placeholder="이름을 입력해주세요."
              :disabled="isRegDone || checkedSameName"
              :onFocusIn="handleFocus"
              :onFocusOut="handleFocusOut"
              v-model="params.cstmNm"
            />
          </div>
          <div v-if="!isForeigner" class="form-guide-text">
            매각자와 예금주는 동일해야합니다.
          </div>
        </dd>
      </dl>
      <dl class="form-list__row">
        <dt class="form-list__key">
          입금계좌번호
          <span class="font-red">(필수)</span>
        </dt>
        <dd>
          <div style="margin-bottom: 6px;">
            <div class="agrm-form-input-area" style="margin-bottom: 8px;">
              <DxSelectBox
                placeholder="은행 선택"
                displayExpr="cmnsCdNm"
                valueExpr="cmnsCd"
                :dataSource="bankCdList"
                :onClosed="() => handleSelectBoxClick(false)" 
                :onOpened="() => handleSelectBoxClick(true)"
                :disabled="isRegDone"
                name="cmnsCdSelectBox"
                id="cmnsCdSelectBox"
                v-model="params.bankCd"
              />
            </div>
            <div class="agrm-form-input-area" >
              <DxTextBox
                placeholder="- 없이 숫자만 입력해주세요."
                :disabled="isRegDone"
                v-model="om_account_value"
              />
            </div>
          </div>
          <div class="form-guide-text">
            본인 명의의 계좌를 입력해주세요.
          </div>
        </dd>	
      </dl>
    </div>
  </section>
</template>

<script>
import DxTextBox from 'devextreme-vue/text-box'
import DxSelectBox from 'devextreme-vue/select-box'
import { DxCheckBox } from "devextreme-vue/check-box";

export default {
  name: 'BankInfo',
  components: {
    DxCheckBox,
    DxTextBox,
    DxSelectBox
  },
  props: [
    'isRegDone',
    'isPassYn',
    'isForeigner',
    'orgCstmNm',
    'temp_om_account',
    'bankCdList',
    'ordInfo'
  ],
  data: () => ({
    om_account_value: '',
    params: {
      cstmNm: '',
      bankCd: '',
      cstmAccnNum: null
    },
    cstmDpstNm: '',
    checkedSameName: false
  }),
  watch: {
    temp_om_account (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.om_account_value = this.temp_om_account
      }
    },
    om_account_value (newVal, oldVal) {
      if (newVal !== oldVal) {
        const regex = /[^0-9]/g
        const result = `${newVal}`.replace(regex, '')
        this.om_account_value = result
        this.params.cstmAccnNum = result
      }
    },
    params: {
      deep: true,
      handler (newVal) {
        this.$emit('changeBankInfo', newVal)
      }
    },
    ordInfo () {
      this.params.bankCd = this.ordInfo.bankCd
      this.params.cstmNm = this.ordInfo.cstmNm
      this.cstmDpstNm = this.ordInfo.cstmDpstNm
    }
  },
  created () {
    this.om_account_value = this.temp_om_account
    this.event_value = this.temp_event
    if (this.ordInfo) {
      this.params.bankCd = this.ordInfo.bankCd
      if (this.isRegDone) {
        this.params.cstmNm = this.ordInfo.cstmDpstNm
      }
    }
  },
  mounted () {
  },
  methods: {
    handleFocus (e) {
      const trgtHeight = e.element.offsetHeight + 90
      window.scrollTo(0, trgtHeight)
    },
    handleFocusOut (e) {
    },
    certPass (e) {
      this.$emit('certPass')
    },
    handleSelectBoxClick (isOpened) {
      if (isOpened) {
        document.body.id = 'TalkDeposit'
        return
      }
      if (!isOpened && document.body.id === 'TalkDeposit') {
        document.body.id = ''
      }
    },
    handleCheckedSameName(e){
      const { value, event } = e;
      if(value){
        this.params.cstmNm = this.orgCstmNm;
      }
    }
  }
}
</script>

<style scoped>
  .div-checkedSameName{
    width : 100px;
  }

  @media only screen and (max-width: 1260px){
    .div-checkedSameName {
      text-align : right; 
      float : right;
    }
  }

</style>


// WEBPACK FOOTER //
// src/views/purchase/sale/components/BankInfo.vue